import { createContext } from 'react';

// @ts-ignore
const RouteDataLoaderContext = createContext();

export default RouteDataLoaderContext;
